import { render, staticRenderFns } from "./RatingStarsComp.vue?vue&type=template&id=287eb442&"
import script from "./RatingStarsComp.vue?vue&type=script&lang=js&"
export * from "./RatingStarsComp.vue?vue&type=script&lang=js&"
import style0 from "./RatingStarsComp.vue?vue&type=style&index=0&id=287eb442&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports